import React, { useContext } from 'react';
import type OrderItem from '@this/src/domain/order_item';
import CoreAppContext from '@this/components/core_app/core_app_context';
import { createCalendarLink, formatMainContentBodyText, formatDate, isAllday } from '../trip_calendar_helpers';
import type { Theme } from '../trip_calendar_helpers';
import { CalendarLinkButton } from './calendar_link_button';

interface OutlookCalendarAddButtonProps {
  trip: any;
  user: any;
  theme: Theme;
  orderItem: OrderItem;
}

const OutlookCalendarAddButton: React.FC<OutlookCalendarAddButtonProps> = ({ trip, user, theme, orderItem }) => {
  const { serviceId } = useContext(CoreAppContext);

  const calendarLink = createCalendarLink(
    orderItem.mappingDescription(),
    formatMainContentBodyText(orderItem, trip, user.id, theme, serviceId, 'outlook'),
    formatDate(orderItem, 'outlook'),
    formatDate(orderItem, 'outlook', true),
    'outlook',
    isAllday(orderItem)
  );

  return (
    <CalendarLinkButton href={calendarLink}>
      <img
        src="/images/outlook-icon.png"
        style={{
          width: '14px',
          height: '14px',
          marginRight: '4px'
        }}
        alt="Outlook"
      />
      <span
        style={{
          fontSize: '11px',
          letterSpacing: '0'
        }}
      >
        Outlookカレンダーに追加
      </span>
    </CalendarLinkButton>
  );
};

export default OutlookCalendarAddButton;
